import $, { map } from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import fb from "@bd-core/firebase";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import Screen from "@bd-utils/screen";
import { getState } from "@bd-stores/store";
import {
    getRoomStatus,
    getPlayers,
    getFinalTeamAnswers,
    getLeader,
    getSelectedCase,
} from "@bd-stores/game-progress";
import {
    removeSelectedCase,
    updateAttributes,
} from "@bd-core/firebase-actions";
import bdapi from "@bd-core/bd-api";
import gsap from "gsap";
import Draggable from "gsap/Draggable";

export class MainRoom extends BD_Component {
    constructor() {
        super();

        this.id = "main-room";
        this.templateID = "main-room-template";

        this.elms = {
            roomItem: ".js-room-item",
            finishGameBtn: ".js-finish-game-btn",
            background: ".js-screen-img",
            backgroundImage: ".screen__img",
            zoomIn: ".js-zoom-in",
            zoomOut: ".js-zoom-out",
            hintItem: ".js-hint",
            audioItem: ".js-audio",
            audioItemFile: ".js-audio-file",
            readyBtn: ".js-ready-btn",
            allReadyBtn: ".js-all-ready-btn",
            case: ".home__case",
            caseBtn: ".js-case-btn",
            selectionLeader: ".js-selection-leader",
            selectionTitle: ".js-selection-title",
            selectionSubtitle: ".js-selection-subtitle",
            playersReadyList: ".home__card_players",
        };

        this._events = this.getEvents();
        this.fbListeners = [];

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.backgroundWidth = 5760;
        this.backgroundHeight = 2160;

        this.isReady = false;
        this.allReady = false;
        this.isLeader = false;
        this.leader = 0;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.finishGameBtn,
                handler: this.finishGame,
            },
            {
                event: "click",
                selector: elms.zoomIn,
                handler: this.onZoomIn,
            },
            {
                event: "click",
                selector: elms.zoomOut,
                handler: this.onZoomOut,
            },
            {
                event: "change",
                selector: elms.hintItem,
                handler: this.onClickedHint,
            },
            {
                event: "click",
                selector: elms.audioItem,
                handler: this.onClickAudio,
            },
            {
                event: "click",
                selector: elms.readyBtn,
                handler: this.onToggleReady,
            },
            {
                event: "click",
                selector: elms.case,
                handler: this.onCaseClick,
            },
            {
                event: "click",
                selector: elms.caseBtn,
                handler: this.onCaseButtonClick,
            },
            {
                event: "click",
                selector: document,
                handler: this.onCaseOutsideClick,
            },
        ];
    }

    beforeInit() {
        window.screenCalculationFunc = () => Screen.calculateCoverSize();

        this.render();
        this.setGameState();
        this.listenUsersReady();
        this.listenTeamAttributes();
    }

    modifiedData() {
        const data = this._data;

        if (Object.keys(data).length == 0) return {};

        map(data.rooms, (room) => {
            let is_main_room = false;

            if (room.hotspot_type == "room") {
                is_main_room = true;
            }

            if (room.hotspot_type == "hint") {
                const font_fam = room.hint_font_family.split("|");
                const font_name = font_fam[0];
                const font_category = font_fam[1];

                room.font_family = `"${font_name}", ${font_category}`;
            }

            room.isMainRoom = is_main_room;

            return room;
        });

        let data_rooms = [];
        data.rooms.forEach((room) => {
            if (room.mainroom_id == data.room_id) {
                data_rooms.push(room);
            }
        });

        return {
            ...data,
            rooms: data_rooms,
        };
    }

    render() {
        const data = this.modifiedData();
        const mainroomStyle = data.mainroom_style;
        let templateID = "main-room-template";

        if (typeof mainroomStyle == "string") {
            templateID = mainroomStyle + "-template";
        }

        const htmlTemplate = $("#" + templateID).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);
    }

    setGameState() {
        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        const usersStateFinish = getFinalTeamAnswers(roomID);

        const leaderID = getLeader();
        this.leader = leaderID;
        this.isLeader = leaderID === CONFIG.user.id;
        const leader = getPlayers().find((p) => p.userId === leaderID);
        $(this.elms.selectionLeader).css("background-color", leader.colorHex);

        if (usersStateFinish) {
            const finishState = bdjs.indexedObjectToArray(usersStateFinish);
            const myState = finishState.find((uID) => uID == currentPlayerId);

            if (myState) {
                const waitingText = $(".waiting-others-text").text();
                const $finishBtn = $(this.elms.btnFinishGame);

                $finishBtn.addClass("is-waiting");
                $finishBtn.find("span").text(waitingText);
            }
        }

        const gameProgress = getState().gameProgress;
        const roomStatuses = gameProgress.roomStatus;
        const isAllRoomCompleted = gameProgress.allRoomCompleted;

        $.each(roomStatuses, function (roomID, status) {
            $(`.js-room-item[data-page="${roomID}"]`).removeClass(
                "is-complete",
            );
            if (status == "is-status-completed") {
                $(`.js-room-item[data-page="${roomID}"]`).addClass(
                    "is-complete",
                );
            }
        });

        if (isAllRoomCompleted) {
            $("#page-mainroom").addClass("is-room-completed");
            $(this.elms.selectionTitle).text("You've completed all cases");
            $(this.elms.selectionSubtitle).text("You can close the game");
            $(this.elms.selectionLeader).hide();
            if (this.isLeader) {
                $(this.elms.finishGameBtn).addClass(
                    "is-room-completed is-leader",
                );
            }
        }

        this.updateRoomRequirements();

        $(this.elms.backgroundImage).on("load", () => {
            if ($(this.elms.backgroundImage).hasClass("js-draggable")) {
                this.initBackground();
                this.setMoveable();
                $(window).on("resize", () => {
                    this.resetDraggableParams();
                });
            }
        });
    }

    // ============================== CUSTOM FUNCTION

    initBackground() {
        let backWidth = $(this.elms.backgroundImage).prop("naturalWidth"),
            backHeight = $(this.elms.backgroundImage).prop("naturalHeight");
        this.backgroundWidth = !backWidth ? 4096 : backWidth;
        this.backgroundHeight = !backHeight ? 1536 : backHeight;
        setTimeout(() => {
            $(this.elms.backgroundImage).removeAttr("style");
            $(this.elms.background).removeAttr("style");
            $(".js-draggable").css({
                width: `${this.backgroundWidth}px`,
                height: `${this.backgroundHeight}px`,
            });
        }, 400);
    }

    resetDraggableParams() {
        $(".js-draggable").css({
            width: `${this.backgroundWidth}px`,
            height: `${this.backgroundHeight}px`,
            transform: `translate(-50%, -50%)`,
        });
        this.startX = 0;
        this.startY = 0;
        gsap.set(".js-draggable", { clearProps: "transform" });
    }

    onZoomIn() {
        if (this.zoom < 120) {
            this.zoom += 5;
            this.backgroundWidth += this.backgroundWidth * 0.05;
            this.backgroundHeight += this.backgroundHeight * 0.05;
            this.resetDraggableParams();
        }
    }

    onZoomOut() {
        if (this.zoom > 100) {
            this.zoom -= 5;
            this.backgroundWidth -= this.backgroundWidth * 0.05;
            this.backgroundHeight -= this.backgroundHeight * 0.05;
            this.resetDraggableParams();
        }
    }

    setMoveable() {
        gsap.registerPlugin(Draggable);
        let companions;

        Draggable.create(".js-draggable", {
            bounds: $(".screen__container"),
            dragResistance: 0.5,
            edgeResistance: 1,
            allowContextMenu: true,
            type: "x,y",
            zIndexBoost: false,
            onPress: function () {
                const screens = document.querySelectorAll(".js-draggable");
                let i = screens.length;
                companions = [];
                MainRoom.prototype.startX = this.x;
                MainRoom.prototype.startY = this.y;
                while (--i > -1) {
                    if (companions[i] !== this.target) {
                        companions.push({
                            element: screens[i],
                            x: gsap.getProperty(screens[i], "x"),
                            y: gsap.getProperty(screens[i], "y"),
                        });
                    }
                }
                gsap.killTweensOf(".js-draggable");
            },
            onDrag: function () {
                let i = companions.length,
                    deltaX = this.x - MainRoom.prototype.startX,
                    deltaY = this.y - MainRoom.prototype.startY,
                    companion;
                while (--i > -1) {
                    companion = companions[i];
                    gsap.set(companion.element, {
                        x: companion.x + deltaX,
                        y: companion.y + deltaY,
                    });
                }
            },
        });
    }

    updateRoomRequirements() {
        const rooms = CONFIG.game.rooms;
        const leaderID = getLeader();
        this.leader = leaderID;
        this.isLeader = leaderID === CONFIG.user.id;
        const selectedCaseID = getSelectedCase();

        const isAllRoomCompleted = getState().gameProgress.allRoomCompleted;

        if (isAllRoomCompleted) {
            $("#page-mainroom").addClass("is-room-completed");
            $(this.elms.selectionTitle).text("You've completed all cases");
            $(this.elms.selectionSubtitle).text("You can close the game");
            $(this.elms.selectionLeader).hide();
            if (this.isLeader) {
                $(this.elms.finishGameBtn).addClass(
                    "is-room-completed is-leader",
                );
            }
        }

        $.each(rooms, (index, room) => {
            const isSelectedCase = room.id === selectedCaseID;
            const requirements = room.requirements;
            const $roomItem = $(`.js-room-item[data-page="${room.id}"]`);

            const gameProgress = getState().gameProgress;
            const roomStatus = gameProgress.roomStatus[room.id];

            $roomItem.removeClass("is-locked is-chosen is-waiting is-ready");

            if (
                !this.isLeader &&
                !isSelectedCase &&
                roomStatus !== "is-status-completed"
            ) {
                $roomItem.removeClass("is-chosen");
                $roomItem.addClass("is-locked").prop("disabled", true);
            } else {
                let state = "";
                if (isSelectedCase) {
                    if (this.isReady) {
                        const $caseBtn = $roomItem.find(".home__action_btn");
                        if (this.isLeader && this.allReady) {
                            state = "is-ready";

                            $caseBtn.attr("data-change-page", room.id);
                        } else {
                            state = "is-waiting";

                            $caseBtn.removeAttr("data-change-page");
                        }
                    } else {
                        state = "is-chosen";
                    }
                }
                $roomItem.addClass(state).prop("disabled", false);
            }

            let isLocked = false;
            $.each(requirements, (index, roomID) => {
                const roomStatus = getRoomStatus(roomID);

                if (roomStatus !== "is-status-completed") {
                    isLocked = true;
                    return false;
                }
            });

            isLocked
                ? $roomItem.addClass("is-locked").prop("disabled", true)
                : $roomItem.prop("disabled", false);
        });
    }

    finishGame() {
        bdjs.showLoading();
        const gameProgress = getState().gameProgress;

        if (gameProgress.allRoomCompleted && this.isLeader) {
            updateAttributes({
                gameStatus: "is-status-completed",
            });
        }
    }

    onToggleReady() {
        const readyState = !this.isReady;
        fb.update(fb.currentPlayerPath, {
            ready: readyState,
        });
    }

    maybeReadyToStart(snapshot) {
        const value = snapshot.val();
        const players = bdjs.indexedObjectToArray(value);

        const isAllRoomCompleted = getState().gameProgress.allRoomCompleted;

        if (isAllRoomCompleted) {
            $("#page-mainroom").addClass("is-room-completed");
            $(this.elms.selectionTitle).text("You've completed all cases");
            $(this.elms.selectionSubtitle).text("You can close the game");
            $(this.elms.selectionLeader).hide();
            if (this.isLeader) {
                $(this.elms.finishGameBtn).addClass(
                    "is-room-completed is-leader",
                );
            }

            return;
        }

        if (players.length) {
            let validPlayers = 0;
            let readyPlayers = 0;

            $(this.elms.playersReadyList).html("");
            const isAdmin = CONFIG.isAdmin === "1" ? true : false;
            const minimalPlayers = isAdmin ? 0 : 1;
            players.forEach((player) => {
                if (player.ready) {
                    const isPlayer =
                        player.userId === CONFIG.user.id ? "is-player" : "";
                    const addedReadyPlayer = `<div class="home__card_player ${isPlayer}" style="background-color:${player.colorHex};">
                                        <span><?php _e("You", "danone-arbogame"); ?></span>
                                    </div>`;
                    $(this.elms.playersReadyList).append(addedReadyPlayer);

                    readyPlayers++;
                }
                if (player.userId && player.isOnline) validPlayers++;

                if (players.length > minimalPlayers) {
                    this.allReady =
                        readyPlayers > minimalPlayers && readyPlayers === validPlayers;
                }
            });

            const player = players.find((p) => p.userId === CONFIG.user.id);
            if (!player) return;
            this.isReady = player.ready;

            const mainroomData = CONFIG.game.rooms.find(
                (room) => room.id === this.roomId,
            );
            let selectionData = {};
            if (mainroomData && "selection" in mainroomData.room) {
                selectionData = mainroomData.room.selection;
            }

            const leader = players.find((p) => p.userId === this.leader);
            if (!leader) return;

            if (this.isLeader) {
                $(this.elms.selectionTitle).css("display", "block");
                $(this.elms.selectionLeader).css("display", "none");
                $(this.elms.selectionSubtitle).css("display", "none");
            } else {
                $(this.elms.selectionTitle).css("display", "none"); 
                $(this.elms.selectionLeader).css("display", "block");
                $(this.elms.selectionSubtitle).css("display", "block");
            }

            if (!this.allReady) {
                this.updateRoomRequirements();

                const subtitle = selectionData.waiting.subtitle.replace(
                    "{player}",
                    leader.name,
                );
                $(this.elms.selectionTitle).html(selectionData.waiting.title);
                $(this.elms.selectionSubtitle).html(subtitle);
            } else {
                this.updateRoomRequirements();

                const subtitle = selectionData.ready.subtitle.replace(
                    "{player}",
                    leader.name,
                );
                $(this.elms.selectionTitle).html(selectionData.ready.title);
                $(this.elms.selectionSubtitle).html(subtitle);
            }
        }
    }

    listenUsersReady() {
        const path = fb.playersPath;

        this.fbListeners.push(
            fb.onValue(path, this.maybeReadyToStart.bind(this)),
        );
    }

    maybeTeamAttributesChange(snapshot) {
        const value = snapshot.val();

        if (value.gameStatus === "is-status-completed") {
            bdjs.goAsync(
                bdapi.post("game/finish-game", {
                    middle_state: getState().gameProgress.isMiddleState ? 1 : 0,
                }),
            );
            return;
        }

        this.allReady = false;
        this.updateRoomRequirements();
    }

    listenTeamAttributes() {
        const path = fb.teamAttributesPath;

        this.fbListeners.push(
            fb.onValue(path, this.maybeTeamAttributesChange.bind(this)),
        );
    }

    beforeDestroy() {
        this.fbListeners.forEach((fn) => fn.call());
        this.fbListeners = [];
    }

    onClickedHint(e, el) {
        const elms = this.elms;
        const thisId = $(el).attr("id");
        const hintHotspots = $(elms.hintItem);

        $.each(hintHotspots, (index, item) => {
            const $item = $(item);
            const itemID = $item.attr("id");

            if (itemID !== thisId) {
                $item.prop("checked", false);
            }
        });
    }

    onClickAudio(e, el) {
        const elms = this.elms;
        const thisId = $(el).attr("id");
        const audioHotspot = $(elms.audioItem);

        $(elms.hintItem).prop("checked", false);

        const currentAudioID = "#" + thisId.split("audio-")[1];
        const $currAudio = $(currentAudioID).get(0);
        const isPlaying = $(el).hasClass("is-playing");

        // @ts-ignore
        isPlaying ? $currAudio.pause() : $currAudio.play();

        $(el).toggleClass("is-paused", isPlaying);
        $(el).toggleClass("is-playing", !isPlaying);

        $.each(audioHotspot, (index, item) => {
            const $item = $(item);
            const itemID = $item.attr("id");

            const audioID = "#" + itemID.split("audio-")[1];
            const $audio = $(audioID).get(0);

            if (itemID !== thisId) {
                // @ts-ignore
                if ($audio.play()) $audio.pause();

                $item.addClass("is-paused");
                $item.removeClass("is-playing");
            }
        });
    }

    onCaseClick(e, el) {
        const $this = $(el);
        $(".home__case").removeClass("is-chosen");

        if (
            $this.hasClass("is-chosen") ||
            $this.hasClass("is-waiting") ||
            $this.hasClass("is-ready") ||
            $this.hasClass("is-locked") ||
            $this.hasClass("is-complete")
        )
            return false;

        $this.addClass("is-chosen");
    }

    async onCaseButtonClick(e, el) {
        const $this = $(el);
        const $case = $this.closest(".home__case");

        if ($case.hasClass("is-chosen")) {
            if (this.isLeader) {
                const caseID = $case
                    .closest(this.elms.roomItem)
                    .attr("data-page");
                updateAttributes({
                    selectedCase: parseInt(caseID),
                });
            }

            $case.removeClass("is-chosen").addClass("is-waiting");
        } else if ($case.hasClass("is-waiting")) {
            if (this.isLeader) {
                removeSelectedCase();
            }

            $case.removeClass("is-waiting").addClass("is-chosen");
        }

        this.onToggleReady();
    }

    onCaseOutsideClick(e) {
        if (
            this.isLeader &&
            !$(e.target).is(".home__case") &&
            !$(e.target).closest(".home__case").length
        ) {
            $(".home__case").removeClass("is-chosen");
        }
    }
}
